
export default function useBackDropLoadingToggle() {
    const handleBackDropLoadingToggle = (value, setBackDropLoading) => {
        setBackDropLoading(value)
    }
    return { handleBackDropLoadingToggle }
}